import { push, ref, set } from "firebase/database";
import { useState } from "react";
import { database } from "../firebase";

const CreatePassword = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !mobile || !password) {
      alert("All fields are required");
      return;
    }

    try {
      const usersRef = ref(database, "admins");
      const newUserRef = push(usersRef);
      await set(newUserRef, {
        name,
        email,
        mobile,
        password,
      });

      setSuccess("Admin user created successfully!");
      setName("");
      setEmail("");
      setMobile("");
      setPassword("");
    } catch (error) {
      alert("Error saving user: " + error.message);
    }
  };

  return (
    <div className="container mt-5">
      <h2>Create Admin Account</h2>
      {success && <div className="alert alert-success">{success}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter full name"
          />
        </div>
        <div className="mb-3">
          <label>Email ID</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email address"
          />
        </div>
        <div className="mb-3">
          <label>Mobile Number</label>
          <input
            type="text"
            className="form-control"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Enter mobile number"
          />
        </div>
        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
          />
        </div>
        <button className="btn btn-primary" type="submit">
          Create Admin
        </button>
      </form>
    </div>
  );
};

export default CreatePassword;
